"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm-9 7c0-4.9706 4.0294-9 9-9s9 4.0294 9 9-4.0294 9-9 9-9-4.0294-9-9z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.7273c-1.2776 0-2.2417 1.0947-2.2639 2.2727-.023 1.2264 1.0362 2.2727 2.2639 2.2727 1.2247 0 2.2727-1.036 2.2727-2.2727 0-1.2379-1.0348-2.2727-2.2727-2.2727zM12 7c2.7234 0 5 2.2766 5 5s-2.2766 5-5 5-5-2.2766-5-5 2.2766-5 5-5z",
    fill: "#FADC7D"
  })];
};

exports.default = _default;